import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { useFinance } from "./FinanceContext";
import { MONTHS } from "./data/seedData";
import { AnnualBar } from "./components/AnnualBar";
import { CashFlowChart } from "./components/charts/CashFlowChart";
import { toneColor } from "./components/tone";

export function CashFlowPage() {
  const { model, fmt } = useFinance();

  const rows = useMemo(() => {
    const exp = Array(12).fill(0);
    const rev = Array(12).fill(0);
    model.items.forEach((it) => it.actual.forEach((v, m) => (exp[m] += v)));
    model.revenue.forEach((r) => r.actual.forEach((v, m) => (rev[m] += v)));
    let cum = 0;
    return MONTHS.map((mn, i) => {
      const net = (rev[i] ?? 0) - (exp[i] ?? 0);
      cum += net;
      return { mn, rev: rev[i] ?? 0, exp: exp[i] ?? 0, net, cum };
    });
  }, [model]);

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        Cash Flow
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Monthly inflow vs outflow · cumulative position
      </Typography>
      <AnnualBar />
      <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
          Net Cash Flow &amp; Cumulative
        </Typography>
        <CashFlowChart rows={rows} />
      </Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Month</TableCell>
              <TableCell align="right">Inflow</TableCell>
              <TableCell align="right">Outflow</TableCell>
              <TableCell align="right">Net</TableCell>
              <TableCell align="right">Cumulative</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.mn}>
                <TableCell>{r.mn}</TableCell>
                <TableCell align="right" sx={{ color: "success.main" }}>
                  {fmt(r.rev)}
                </TableCell>
                <TableCell align="right" sx={{ color: "error.main" }}>
                  {fmt(r.exp)}
                </TableCell>
                <TableCell align="right" sx={{ color: toneColor(r.net >= 0 ? "pos" : "neg") }}>
                  {fmt(r.net)}
                </TableCell>
                <TableCell align="right" sx={{ color: toneColor(r.cum >= 0 ? "pos" : "neg") }}>
                  {fmt(r.cum)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
